// Handle 404 errors

import { Link, useNavigate } from "@remix-run/react";
import { Button } from "@heroui/button";

export default function Component() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="bg-green-900 text-white">
        <Link to="/reach">
          {" "}
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            Mirantus
          </span>
        </Link>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center p-6">
        <h1 className="text-6xl font-bold text-red-500 mb-4">404</h1>
        <p className="text-2xl text-gray-800 mb-6">
          Du hast eine Seite gefunden, die es nicht gibt.
        </p>
        <div className="flex items-center justify-center mb-6">
          <img
            src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMno1aXRiNXNnb2o4OWhiNndkMnplcWFobHhibzd6ZHM5a3Q5eDZjbSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/8L0Pky6C83SzkzU55a/giphy.gif"
            alt="404 Not Found"
            className="w-64 h-auto rounded-lg shadow-md"
          />
        </div>
        <p className="text-lg text-gray-600 mb-8">
          Es sieht so aus, als ob du dich verlaufen hättest. Bringen wir dich
          zurück nach Hause.
        </p>
        <Button
          color="primary"
          radius="full"
          onPress={() => navigate(-1)}
          // className="px-6 py-3 bg-green-500 text-white text-lg font-semibold rounded-md shadow-md hover:bg-green-600 transition duration-300"
        >
          Zurück
        </Button>
      </div>
    </div>
  );
}
